import Dexie from "dexie"

const dbName = "ImportedDataV2"
function openDB() {
  //set the database
  const db = new Dexie(dbName)
  //create the database store
  db.version(1).stores({
    data: "id, data, columns, invalidItems, validation, curFileName, curFileContent",
  })
  db.open().catch(err => {
    //console.log(err.stack || err)
  })
  return db
}

export async function getData() {
  const db = openDB()
  const data = await db.data.toArray()
  return data?.length > 0 ? data[0] : null
}

export async function clearData() {
  const db = openDB()
  const allData = await db.data.toArray()
  if (allData && allData[0]) {
    db.data.delete(1)
  }
}

export async function addData(item) {
  try {
    const db = openDB()
    const allData = await db.data.toArray()
    if (allData && allData[0]) {
      db.data.delete(1)
    }

    db.data.add(item)
  } catch (e) {
    console.warn(e, item)
  }
}
